import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, Grid } from '@material-ui/core';
import { FHEContainerForm, FHEItemText, FHEDivider, FormEditButton, FHETextField, FHEReactSelect } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { updateProductModule } from '../../../../../data/Products/actions';
import memoizeOne from "memoize-one";

class Pilotwire extends PureComponent {
    static propTypes = {
        enumProductModulesTypes: PropTypes.array.isRequired,
        theme: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        planningMode: PropTypes.string,
        moduleType: PropTypes.string,
        productType: PropTypes.string,
        code: PropTypes.string,
        lineType: PropTypes.string,
        planningSynched: PropTypes.number,
        value: PropTypes.string,
        label: PropTypes.string,
        planningType: PropTypes.string,
        favorite: PropTypes.number,
        updateProductModule: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        expanded: PropTypes.string,
        productModulekey: PropTypes.string.isRequired,
        profile: PropTypes.object.isRequired,
        type: PropTypes.string
    };

    static defaultProps = {
        expanded: null,
        planningMode: null,
        moduleType: null,
        productType: null,
        code: null,
        lineType: null,
        planningSynched: null,
        value: null,
        label: null,
        planningType: null,
        favorite: null,
        type: null
    };

    constructor(props) {
        super(props);
        this.state = {
            formDisabled: true,
            textInput_error: {},
            sendLoading: false,
            form: {
                moduleType: null,
                label: null,
                favorite: null
            }
        };

        this.favorites = [
            { value: 0, label: Translator.translate('general.productModules.0') },
            { value: 1, label: Translator.translate('general.productModules.1') }
        ];
    }

    static getDerivedStateFromProps(props, state) {
        const { formDisabled } = state;
        const { moduleType, label, favorite } = props;
        if (formDisabled) {
            let form = {
                moduleType: state.form.moduleType,
                label: state.form.label,
                favorite: state.form.favorite
            };
            if (props.moduleType !== state.form.moduleType) {
                form.moduleType = moduleType;
            }
            if (props.label !== state.form.label) {
                form.label = label;
            }
            if (props.favorite !== state.form.favorite) {
                form.favorite = favorite;
            }
            return {
                form: form
            };
        } else {
            return null;
        }
    }

    handleEdit = () => {
        const { formDisabled } = this.state;
        this.setState({
            formDisabled: !formDisabled
        });
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });

        this.setState({
            textInput_error: res
        });

        return Toastr.error(message);
    };

    handleChangeWithVerification = event => {
        const { form, textInput_error } = this.state;
        let targetValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        const fieldLengthRules = {
            label: 255
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = form[event.target.name];
        if (targetValue === '') targetValue = null;

        this.setState({
            form: { ...form, [event.target.name]: targetValue },
            textInput_error: newTextInput_error
        });
    };

    handleChange = event => {
        const { form } = this.state;

        let value;
        if (event.target.name === 'favorite') {
            value = parseInt(event.target.value);
        } else {
            value = event.target.value;
        }

        this.setState({
            form: { ...form, [event.target.name]: value }
        });
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    loadInputs = () => {
        const { moduleType, label, favorite } = this.props;
        this.setState({
            formDisabled: true,
            textInput_error: {},
            sendLoading: false,
            form: {
                moduleType: moduleType,
                label: label,
                favorite: favorite
            }
        });
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };

    formatForm = () => {
        const { form } = this.state;
        let newForm = form;
        Object.keys(newForm).forEach(key => {
            if (newForm[key] === '') {
                newForm[key] = null;
            }
        });
        this.setState({
            form: newForm
        });
    };

    confirmEdit = () => {
        const { form } = this.state;
        const { updateProductModule, match, code, type, lineType, history } = this.props;

        this.formatForm();

        if (this.validateForm(form)) {
            this.setState({
                sendLoading: true,
                formDisabled: true
            });

            return updateProductModule(match.params.homeId, match.params.productIdentifier, match.params.productType, code, form, type, lineType)
                .then(() => {
                    Toastr.success(Translator.translate(`generic.products.actions.editProductModuleSuccess`));
                    this.loadInputs();
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                        formDisabled: false
                    });
                    Toastr.error(Translator.translate(`generic.products.actions.editProductModuleError`));
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(error.validation.errors, Translator.translate(`generic.products.actions.editProductModuleError`));
                    }
                });
        }
    };

    validateForm = () => {
        const errors = {};

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    };

    getSelectedFavorite = memoizeOne(favorite => {
        return this.favorites.find(x => x.value === favorite);
    });

    getSelectedType = memoizeOne(type => {
        const { enumProductModulesTypes } = this.props;
        return enumProductModulesTypes.find(x => x.value === type);
    });

    handleReactSelect = (event, options) => {
        const { form } = this.state;

        this.setState({
            form: { ...form, [options.name]: event.value }
        });
    };
    render() {
        const {
            enumProductModulesTypes,
            planningMode,
            productType,
            code,
            lineType,
            planningSynched,
            value,
            planningType,
            theme,
            expanded,
            productModulekey,
            profile,
            history,
            type
        } = this.props;
        const { formDisabled, textInput_error, sendLoading, form } = this.state;
        const userRightUpdate =
            profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`productModules_${type}_${lineType}_update`);

        return (
            <Fragment>
                {expanded === productModulekey && userRightUpdate && (
                    <FormEditButton
                        useSecondaryPosition
                        formDisabled={formDisabled}
                        handleEdit={this.handleEdit}
                        confirmEdit={this.confirmEdit}
                        sendLoading={sendLoading}
                    />
                )}

                <FHEContainerForm withoutPadding>
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHETextField
                                disabled={formDisabled}
                                id="label"
                                value={!form.label || form.label === null ? '' : form.label}
                                error={textInput_error.label}
                                label={Translator.translate('general.table.column.label')}
                                name="label"
                                onChange={this.handleChangeWithVerification}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEReactSelect
                                name="moduleType"
                                label={Translator.translate('general.table.column.moduleType')}
                                disabled={formDisabled}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedType(form.moduleType)}
                                choices={enumProductModulesTypes}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEReactSelect
                                name="favorite"
                                label={Translator.translate('general.table.column.favorite')}
                                disabled={formDisabled}
                                onChange={this.handleReactSelect}
                                value={this.getSelectedFavorite(form.favorite)}
                                choices={this.favorites}
                            />
                        </Grid>
                    </Grid>
                    <FHEDivider color={theme.palette.colors.grey100} />
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.productType')}
                                itemContent={Translator.translate(`general.productModules.${productType}`)}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.lineType')}
                                itemContent={Translator.translate(`general.productModules.${lineType}`)}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.code')} itemContent={code} />
                        </Grid>
                    </Grid>
                    <FHEDivider color={theme.palette.colors.grey100} />
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.planningMode')}
                                itemContent={Translator.translate(`general.productModules.${planningMode}`)}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.planningSynched')}
                                itemContent={Translator.translate(`general.productModules.${planningSynched}`)}
                            />
                        </Grid>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText
                                itemTitle={Translator.translate('general.table.column.planningType')}
                                itemContent={Translator.translate(`general.productModules.${planningType}`)}
                            />
                        </Grid>
                    </Grid>
                    <FHEDivider color={theme.palette.colors.grey100} />
                    <Grid container spacing={3}>
                        <Grid container item sm={12} md={6} lg={4}>
                            <FHEItemText itemTitle={Translator.translate('general.table.column.value')} itemContent={value} />
                        </Grid>
                    </Grid>
                </FHEContainerForm>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const productKey = props.productKey;
    const productModulekey = props.productModulekey;
    const product = state.environments[history.environment].data.Products.getIn(['list', productKey], new Map());

    const productModule = state.environments[history.environment].data.Products.getIn(
        ['list', productKey, 'productModules', productModulekey],
        new Map()
    );
    const enums = state.environments[history.environment].enums;
    return {
        enumProductModulesTypes: enums.productModulesTypes || [],
        profile: state.data.user,
        type: product.get('type'),
        planningMode: productModule.get('planningMode'),
        imageName: productModule.get('imageName'),
        moduleType: productModule.get('moduleType'),
        productType: productModule.get('productType'),
        model: productModule.get('model'),
        code: productModule.get('code'),
        lineType: productModule.get('lineType'),
        planningSynched: productModule.get('planningSynched'),
        value: productModule.get('value'),
        label: productModule.get('label'),
        planningType: productModule.get('planningType'),
        productIdentifier: productModule.get('productIdentifier'),
        favorite: productModule.get('favorite'),
        productModulekey
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});
export default withRouter(
    renderEnvComponent(
        'scenes/Products/components/ProductModule/Pilotwire/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        updateProductModule
                    }),
                    dispatch
                )
        )(withStyles(styles, { withTheme: true })(Pilotwire))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/ProductModule/Pilotwire/index.js